<template>
    <div class="container-fluid">
        <Breadcrumb title="Profile"></Breadcrumb>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        Profile content
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: "Profile",
        components: {Breadcrumb},
        methods: {}

    }
</script>

<style scoped>

</style>